export const movieGenres = [
  { name: "Comedy", code: 35, state: "moviesComedy", link: "comedy" },
  { name: "Science Fiction", code: 878, state: "moviesSciFi", link: "scifi" },
  { name: "Action", code: 28, state: "moviesAction", link: "action" },
  { name: "Horror", code: 27, state: "moviesHorror", link: "horror" },
  { name: "Animation", code: 16, state: "moviesAnimation", link: "animation" },
  { name: "Drama", code: 18, state: "moviesDrama", link: "drama" },
  { name: "Fantasy", code: 14, state: "moviesFantasy", link: "fantasy" },
  { name: "Romance", code: 10749, state: "moviesRomance", link: "romance" },
  /* { name: "Adventure", code: 12, state: "moviesAdventure" }, */
  /* { name: "Mystery", code: 9648, state: "moviesMystery" }, */
  /* { name: "Thriller", code: 53, state: "moviesThriller" }, */
];
